export default function isVideo(urlString) {
  const pathname = urlString.startsWith('https://') || urlString.startsWith('http://')
    ? new URL(urlString).pathname
    : urlString;
  return pathname.endsWith('.mpeg') ||
    pathname.endsWith('.webm') ||
    pathname.endsWith('.avi') ||
    pathname.endsWith('.ogv') ||
    pathname.endsWith('.3gp') ||
    pathname.endsWith('.mov') ||
    pathname.endsWith('.mp4');
}
